import { jsx } from '@emotion/react';
import { Fragment, useState } from 'react';
import { Alert, Link } from '@zapier/design-system';
import { hasDismissedBannerBetweenDates } from './utils/hasDismissedBannerBetweenDates';
export const BANNER_IDS = {
    PLAN_LIMIT_100_PERCENT: 'PLAN_LIMIT_100_PERCENT',
    WORKSPACE_HQ_LIMIT_90_PERCENT: 'WORKSPACE_HQ_LIMIT_90_PERCENT',
    WORKSPACE_LIMIT_80_PERCENT: 'WORKSPACE_LIMIT_80_PERCENT',
    WORKSPACE_LIMIT_100_PERCENT: 'WORKSPACE_LIMIT_100_PERCENT',
};
const DISMISSIBLE_BANNER_IDS = new Set([BANNER_IDS.WORKSPACE_LIMIT_80_PERCENT]);
export const shouldRender = (data, isExcludedUrl = false) => {
    var _a, _b;
    return !isExcludedUrl && ((_b = (_a = data === null || data === void 0 ? void 0 : data.currentAccount) === null || _a === void 0 ? void 0 : _a.notifications) === null || _b === void 0 ? void 0 : _b.length) > 0;
};
const renderNotification = ({ notification, onDismiss, }) => {
    var _a;
    switch (notification === null || notification === void 0 ? void 0 : notification.id) {
        case BANNER_IDS.WORKSPACE_HQ_LIMIT_90_PERCENT: {
            return (jsx(Alert, { onDismiss: onDismiss, status: "warning", variant: "banner" },
                jsx("strong", null, "You're running low on tasks."),
                " To prevent your Zaps from being paused,",
                ' ',
                jsx(Link, { href: "/app/planbuilder/plans" }, "update your plan now"),
                "."));
        }
        case BANNER_IDS.PLAN_LIMIT_100_PERCENT: {
            return ((_a = notification === null || notification === void 0 ? void 0 : notification.metadata) === null || _a === void 0 ? void 0 : _a.role) === 'owner' ? (jsx(Alert, { onDismiss: onDismiss, status: "error", variant: "banner" },
                jsx("strong", null, "You've reached your plan's task limit."),
                " Enable pay-per-task billing to keep your Zaps running, or",
                ' ',
                jsx(Link, { href: "https://zapier.com/l/contact-sales" }, "contact Sales"),
                ' ',
                "to manage your plan.")) : (jsx(Alert, { onDismiss: onDismiss, status: "error", variant: "banner" },
                jsx("strong", null, "Your organization has reached its task limit."),
                " To get your Zaps running, contact the owner to increase the task limit."));
        }
        case BANNER_IDS.WORKSPACE_LIMIT_80_PERCENT: {
            return (jsx(Alert, { onDismiss: onDismiss, status: "warning", variant: "banner" },
                jsx("strong", null, "You're running low on tasks."),
                " Your Zaps will be held once you reach the task limit. Contact the account owner to increase the task limit."));
        }
        case BANNER_IDS.WORKSPACE_LIMIT_100_PERCENT: {
            return (jsx(Alert, { onDismiss: onDismiss, status: "error", variant: "banner" },
                jsx("strong", null, "You've reached the task limit."),
                " To get your Zaps running, contact the account owner to increase the task limit."));
        }
        default:
            console.error('Unknown notification banner ID', notification === null || notification === void 0 ? void 0 : notification.id);
    }
};
export const Component = function Workspaces(props) {
    var _a, _b, _c;
    const [canRenderBanner, setCanRenderBanner] = useState(() => {
        const state = {};
        for (const value of props.data.currentAccount.notifications) {
            state[value.id] = !hasBannerBeenDismissedThisBillingPeriod({
                notification: value,
                periodEndDate: props.data.currentAccount.periodEndDate,
                periodStartDate: props.data.currentAccount.periodStartDate,
            });
        }
        return state;
    });
    const handleDismiss = (notification) => {
        try {
            localStorage.setItem(notification.id, JSON.stringify(new Date().toUTCString()));
            setCanRenderBanner(Object.assign(Object.assign({}, canRenderBanner), { [notification.id]: false }));
        }
        catch (_a) {
            console.log(`Failed to save ${notification.id} banner dismissal to localStorage`);
        }
    };
    return (jsx(Fragment, null, (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.currentAccount) === null || _b === void 0 ? void 0 : _b.notifications) === null || _c === void 0 ? void 0 : _c.map((notification, index) => {
        const onDismiss = isBannerDismissible({
            notification,
            periodEndDate: props.data.currentAccount.periodEndDate,
            periodStartDate: props.data.currentAccount.periodStartDate,
        })
            ? () => handleDismiss(notification)
            : undefined;
        return canRenderBanner[notification.id] ? (jsx("div", { key: index }, renderNotification({ notification, onDismiss }))) : null;
    })));
};
const isBannerDismissible = ({ notification, periodEndDate, periodStartDate, }) => DISMISSIBLE_BANNER_IDS.has(notification.id) &&
    !hasBannerBeenDismissedThisBillingPeriod({
        notification,
        periodEndDate,
        periodStartDate,
    });
const hasBannerBeenDismissedThisBillingPeriod = ({ notification, periodEndDate, periodStartDate, }) => hasDismissedBannerBetweenDates({
    dismissedOn: getBannerDismissalDate(notification),
    endDate: periodEndDate,
    startDate: periodStartDate,
});
const getBannerDismissalDate = (notification) => localStorage.getItem(notification.id);
//# sourceMappingURL=Workspaces.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
